"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Spinner_component_exports = {};
__export(Spinner_component_exports, {
  Spinner: () => Spinner,
  SpinnerSize: () => SpinnerSize,
  SpinnerSpeed: () => SpinnerSpeed
});
module.exports = __toCommonJS(Spinner_component_exports);
var import_react = __toESM(require("react"));
var import_ScreenReaderOnlyText = require("../ScreenReaderOnlyText/ScreenReaderOnlyText.component");
var import_Spinner = require("./Spinner.styled");
var _excluded = ["speed", "size", "ariaLabel"];
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SpinnerSpeed = /* @__PURE__ */ function(SpinnerSpeed2) {
  SpinnerSpeed2["slow"] = "slow";
  SpinnerSpeed2["medium"] = "medium";
  SpinnerSpeed2["fast"] = "fast";
  return SpinnerSpeed2;
}({});
var SpinnerSize = /* @__PURE__ */ function(SpinnerSize2) {
  SpinnerSize2["small"] = "small";
  SpinnerSize2["medium"] = "medium";
  SpinnerSize2["large"] = "large";
  return SpinnerSize2;
}({});
var spinnerSettings = {
  speedSettings: _defineProperty(_defineProperty(_defineProperty({}, SpinnerSpeed.fast, 0.5), SpinnerSpeed.medium, 1), SpinnerSpeed.slow, 2),
  sizeSettings: _defineProperty(_defineProperty(_defineProperty({}, SpinnerSize.large, 16), SpinnerSize.medium, 8), SpinnerSize.small, 4)
};
var Spinner = function Spinner2(_ref) {
  var _ref$speed = _ref.speed, speed = _ref$speed === void 0 ? "medium" : _ref$speed, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "" : _ref$ariaLabel, props = _objectWithoutProperties(_ref, _excluded);
  var speedSettings = spinnerSettings.speedSettings, sizeSettings = spinnerSettings.sizeSettings;
  return /* @__PURE__ */ import_react.default.createElement(import_Spinner.StyledWrapper, _extends({
    role: "status",
    sizeValue: sizeSettings[size]
  }, props), /* @__PURE__ */ import_react.default.createElement(import_Spinner.StyledSpinner, {
    "data-testid": "spinner",
    speedValue: speedSettings[speed]
  }), /* @__PURE__ */ import_react.default.createElement(import_ScreenReaderOnlyText.ScreenReaderOnlyText, {
    text: ariaLabel || "Loading, please wait"
  }));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Spinner,
  SpinnerSize,
  SpinnerSpeed
});
//# sourceMappingURL=Spinner.component.js.map